import { CreditCardType } from 'src/models/creditCard.models'
import { CreditCardPermissions } from 'src/models/creditCardPermissions.models'
import { VirtualCardStatus } from 'src/models/virtualCard.models'
import {
  StatisticAggregateType,
  StatisticModelType,
  StatisticRequest,
} from 'src/requests/statistics.request'

// TODO: add the remaining keys from globalDebouncedDispatcher appStatisticsKeys
export enum StatisticsKeys {
  CreditCardsSourcePhysicalClearingsLinkedCount = 'CreditCardsSourcePhysicalClearingsLinkedCount',
  VirtualCardsActiveCount = 'VirtualCardsActiveCount',
  VirtualCardsCount = 'VirtualCardsCount',
  BudgetsCount = 'BudgetsCount',
}

export const StatisticsRequestsBody: Record<StatisticsKeys, StatisticRequest> =
  {
    [StatisticsKeys.CreditCardsSourcePhysicalClearingsLinkedCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        type: CreditCardType.Source,
        physicalClearingsEnabled: true,
        withPermission: CreditCardPermissions.Read,
      },
    },
    [StatisticsKeys.VirtualCardsActiveCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.VirtualCard,
      query: {
        status: VirtualCardStatus.Active,
      },
    },
    [StatisticsKeys.VirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.VirtualCard,
      query: {},
    },
    [StatisticsKeys.BudgetsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {},
    },
  }
